
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as new9YR0kGbf_45_45IOfKg4bA_45avsTKhNc95QmLJQvSOLgIcGoMeta } from "/Users/david/clawd/localauthority/app/pages/new.vue?macro=true";
import { default as indexyMjfYhUa3r6EbvhmjQG9OU1FXHpTNTLlnlyTp0__qv8Meta } from "/Users/david/clawd/localauthority/app/pages/index.vue?macro=true";
import { default as discoverMoeU6hAR9OaGa9YBTNOz9sGOLGE916QbFCdoU13p8bQMeta } from "/Users/david/clawd/localauthority/app/pages/discover.vue?macro=true";
import { default as editPjrAZH9VIHvRuo1ZrnjvbgPDtfO642AV4bzLogXrzjQMeta } from "/Users/david/clawd/localauthority/app/pages/[id]/edit.vue?macro=true";
import { default as indexrAABSxLUWrQLPaysh6D_DgOFAwTn6QKCgTa7a72WVRUMeta } from "/Users/david/clawd/localauthority/app/pages/[id]/index.vue?macro=true";
export default [
  {
    name: "new",
    path: "/new",
    component: () => import("/Users/david/clawd/localauthority/app/pages/new.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/david/clawd/localauthority/app/pages/index.vue")
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/Users/david/clawd/localauthority/app/pages/discover.vue")
  },
  {
    name: "id-edit",
    path: "/:id()/edit",
    component: () => import("/Users/david/clawd/localauthority/app/pages/[id]/edit.vue")
  },
  {
    name: "id",
    path: "/:id()",
    meta: indexrAABSxLUWrQLPaysh6D_DgOFAwTn6QKCgTa7a72WVRUMeta || {},
    component: () => import("/Users/david/clawd/localauthority/app/pages/[id]/index.vue")
  }
]